import type { SetVariableActionNode } from "../../types.js";
import {
  extractUpstreamValueSubgraph,
  SET_VARIABLE_FLOW_OUT_PORT_ID,
  SET_VARIABLE_VALUE_PORT_ID,
} from "../../variable-graph.js";
import {
  BehaviorFlow,
  ExecutionContext,
  NodeExecutionResult,
  PatchResult,
  RuntimeSignal,
} from "../types.js";
import { emptyPatchResult } from "../helpers.js";
import { BehaviorNode } from "./BehaviorNode.js";

/**
 * Captures the upstream subgraph wired to the `value` port and stores it
 * as a scene variable override via `context.variableOverrideApi`.
 */
export class SetVariableBehaviorNode extends BehaviorNode {
  declare behavior: SetVariableActionNode;

  constructor(behavior: SetVariableActionNode) {
    super(behavior);
  }

  execute(context: ExecutionContext): NodeExecutionResult {
    const patch: PatchResult = emptyPatchResult();
    const nextFlows: BehaviorFlow[] = [];
    const scheduledNodes: never[] = [];
    const runtimeSignals: RuntimeSignal[] = [];

    const { variableId } = this.behavior;
    const { variableOverrideApi, parentRuntime } = context;

    if (variableOverrideApi && parentRuntime) {
      const override = extractUpstreamValueSubgraph(
        parentRuntime,
        this.behavior.id,
        SET_VARIABLE_VALUE_PORT_ID,
      );
      if (override) {
        variableOverrideApi.set(variableId, override);
      }
    }

    const outEdges =
      this.outgoingEdgesByPort.get(SET_VARIABLE_FLOW_OUT_PORT_ID) ?? [];
    for (const edge of outEdges) {
      nextFlows.push({ edge, context });
    }

    return { patch, nextFlows, scheduledNodes, runtimeSignals };
  }

  getOutput(
    _portId: string,
    _visiting: Set<string>,
    _context: ExecutionContext,
  ): unknown {
    return undefined;
  }
}
